import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BankAccountsService {
  url = environment.api;

  constructor(private http: HttpClient) {}

  filterBankAccounts(currencyId: any): Observable<any> {
    return of({ list: [] });
  }
}
